import { useEffect, useState } from 'react';
import uuid from 'react-uuid';
import { useLang } from '../../../../hooks/useLang';
import { EcosystemItem } from './ecosystemItem';
import tenetixDesignLogo from '../../../../assets/tenetixDesignLogo.svg';
import tenetixAcademyLogo from '../../../../assets/tenetixAcademylogo.svg';

import './ecosystem.css';


export function Ecosystem(){

    const {currentLanguage} = useLang();

    const [title, setTitle] = useState([
        'ECOSYSTEM'
    ]);

    const [sectionText, setSectionText] = useState([
        [tenetixDesignLogo, 'tenetix design logo', 'Digital product design UX/UI systems and AI-driven interfaces for modern companies', 'Go to DESIGN', 'https://tenetix.digital/design/'],
        [tenetixAcademyLogo, 'tenetyx academy logo', 'Education programs and workshops to help teams integrate AI into business processes', 'Go to ACADEMY', 'https://tenetix.academy/']
    ]);

    useEffect(() => {
        if(currentLanguage === 'EN'){
            setSectionText([
                [tenetixDesignLogo, 'tenetix design logo', 'Digital product design UX/UI systems and AI-driven interfaces for modern companies', 'Go to DESIGN', 'https://tenetix.digital/design/'],
                [tenetixAcademyLogo, 'tenetyx academy logo', 'Education programs and workshops to help teams integrate AI into business processes', 'Go to ACADEMY', 'https://tenetix.academy/']
            ]);
            setTitle([
                'ECOSYSTEM'
            ]);
        }else if(currentLanguage === 'UK'){
            setSectionText([
                [tenetixDesignLogo, 'tenetix design logo', 'Системи цифрового дизайну продуктів, UX/UI та інтерфейси на основі штучного інтелекту для сучасних компаній', 'Перейти до DESIGN', 'https://tenetix.digital/design/'],
                [tenetixAcademyLogo, 'tenetyx academy logo', 'Освітні програми та семінари, що допоможуть командам інтегрувати штучний інтелект у бізнес-процеси', 'Перейти до ACADEMY', 'https://tenetix.academy/']
            ]);
            setTitle([
                'ЕКОСИСТЕМА'
            ]);
        }
    }, [currentLanguage]);

       return(
        <div className="ecosystem-section">
            <div className='ecosystem-main-container main-container'>
                <h2 className='ecosystem-header'> 
                    {title[0]}
                </h2>
                <div className='ecosystem__content-container'>
                    {
                        sectionText.map((el, index) => (
                            <EcosystemItem data={el} id={uuid()}/>
                        ))
                    }
                </div>
            </div>
        </div>
       );
}